<template>
  <div class="orm-carprice" v-if="!noWrapper">
    <div v-if="Object.keys(tarif.price).length !== 0">
      <p class="text-center orm-color-cta" v-if="tarif.price">
        {{ i18n("cargroup/unitafter") }}
        <span v-if="showNetto" style="white-space: nowrap">{{
          convertCurrency(tarif.price.single_price)
        }}</span>
        <span v-else style="white-space: nowrap">{{
          convertCurrency(tarif.price.long_price)
        }}</span>
        / {{ tarif.price.unit }}
      </p>
    </div>
    <div v-else>
      <p class="text-center orm-color-cta">&nbsp;</p>
    </div>
  </div>
  <div v-else>
    <div v-if="Object.keys(tarif.price).length !== 0">
      {{ i18n("cargroup/unitafter") }}
      <span v-if="showNetto" style="white-space: nowrap">{{
        convertCurrency(tarif.price.single_price)
      }}</span>
      <span v-else style="white-space: nowrap">{{
        convertCurrency(tarif.price.long_price)
      }}</span>
      / {{ tarif.price.unit }}
    </div>
    <div v-else>&nbsp;</div>
  </div>
</template>

<script>
import { convertCurrency } from "@/constants/formater";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import store from "@/store";
import { reactive } from "vue";

export default {
  name: "calcPrice",
  mixins: [i18n, stripHTML],
  props: {
    car: Object,
    noWrapper: {
      type: Boolean,
      required: false,
      default: false,
    },
    showNetto: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["settarif"],
  setup(props, { emit }) {
    const tarif = reactive({ price: {}, all: {} });
    const getPrice = async () => {
      await store
        .dispatch("reservation/CALCULATE_PRICE", {
          id: props.car.id,
          extras: false,
          abo: true,
        })
        .then((res) => {
          if (!res.errors) {
            res.main_rates.forEach((element) => {
              if (element.position == 1) {
                tarif.price = element;
              }
            });
            tarif.all = res;
            emit("settarif", res);
          }
        });
    };
    getPrice();
    return { tarif, convertCurrency };
  },
};
</script>
